import { useState } from 'react';
import { useSelector } from 'react-redux';
import ContentRoutes from 'ContentUtils/Routes';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';

// @ts-expect-error not migrated yet
import { getContentModelName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
// @ts-expect-error not migrated yet
import { getBlogLanguage, getBlogName } from '../redux/selectors/blogSelectors';
// @ts-expect-error not migrated yet
import { getContentModelContentGroupId } from '../redux/selectors/postContentModelSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const NewBlogVariationWarningBanner = () => {
  const blogLanguage = useSelector(getBlogLanguage);
  const blogName = useSelector(getBlogName);
  const blogPostName = useSelector(getContentModelName);
  const blogId = useSelector(getContentModelContentGroupId);
  const [open, setOpen] = useState(true);
  if (open && blogLanguage && blogName && blogPostName) {
    return /*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newBlogVariationWarningAlert.header"
      }),
      type: "warning",
      closeable: true,
      onClose: () => setOpen(false),
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "newBlogVariationWarningAlert.body_jsx",
        options: {
          blogLanguage: I18n.text(`SharedI18nStrings.languageNames.${blogLanguage}`),
          blogName,
          blogPostName,
          settingsLink: ContentRoutes.settings('blog', String(blogId))
        },
        elements: {
          UILink
        }
      })
    });
  }
  return null;
};
export default NewBlogVariationWarningBanner;